import type { ReactNode } from "react";
import { Box, type BoxProps } from "../Box/Box";
import type { Space } from "../Box/useBoxStyles";

interface PageWrapperProps {
  paddingBottom?: Space;
  background?: BoxProps["background"];
  children: ReactNode;
}

export function PageWrapper(props: PageWrapperProps): React.ReactNode {
  const { paddingBottom = "6", background = "white", children } = props;

  return (
    <Box paddingBottom={paddingBottom} background={background} flexGrow={1}>
      {children}
    </Box>
  );
}
